import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from 'src/app/shared/configurations/configurations.factory';
import { Configurations } from 'src/app/shared/configurations/models/configurations.model';
import { ApiEnumerationModel } from '../DTOs/base-DTOs/api-enumeration-model.dto';
import { ApiModel } from '../DTOs/base-DTOs/api-model.dto';
import { ApiObjectModel } from '../DTOs/base-DTOs/api-object-model.dto';
import { LeadInjectorCreateDto, LeadInjectorDto, LeadInjectorUpdateDto } from '../DTOs/lead-injector.dto';

type SortCriteria = 'Id' | 'Enabled' | 'ActivationBegin' | 'ActivationEnd' | 'Updated' | 'Created' | 'Id-' | 'Enabled-' | 'ActivationBegin-' | 'ActivationEnd-' | 'Updated-' | 'Created-'

@Injectable({
  providedIn: 'root'
})
export class LeadInjectorProxyService {

  private readonly baseUrl: string

  constructor(@Inject(APP_CONFIG) config: Configurations, private readonly httpClient: HttpClient) {
    this.baseUrl = config.environmentConfig.lobbyBaseUrl + '/leadinjector'
  }

  getLeadInjector$(id: number | string): Observable<ApiObjectModel<LeadInjectorDto>> {
    return this.httpClient.get<ApiObjectModel<LeadInjectorDto>>(this.baseUrl + `/${id}`)
  }

  getLeadInjectors$(pageIndex: number | null = null,
    pageSize: number | null = null,
    description: string | null = null,
    nota: string | null = null,
    isEnabled: boolean | null = null,
    activationBegin: Date | null = null,
    activationEnd: Date | null = null,
    isActive: boolean | null = null,
    isFacebookEnabled: boolean | null = null,
    sort: SortCriteria | null = null
  ): Observable<ApiEnumerationModel<LeadInjectorDto>> {

    let query: string = '';

    if (pageIndex) query = query + `${query ? '&' : ''}pg_ix=${pageIndex}`
    if (pageSize) query = query + `${query ? '&' : ''}pg_sz=${pageSize}`
    if (description) query = query + `${query ? '&' : ''}description=${description}`
    if (nota) query = query + `${query ? '&' : ''}note=${nota}`
    if (activationBegin) query = query + `${query ? '&' : ''}activationBegin=${activationBegin.toJSON()}`
    if (activationEnd) query = query + `${query ? '&' : ''}activationEnd=${activationEnd.toJSON()}`
    if (isEnabled !== null) query = query + `${query ? '&' : ''}isEnabled=${isEnabled}`
    if (isActive !== null) query = query + `${query ? '&' : ''}isActive=${isActive}`
    if (isFacebookEnabled !== null) query = query + `${query ? '&' : ''}isFacebookEnabled=${isFacebookEnabled}`

    if (sort) query = query + `${query ? '&' : ''}s=${sort}`

    return this.httpClient.get<ApiEnumerationModel<LeadInjectorDto>>(this.baseUrl + `${query ? '?' : ''}${query}`)
  }

  postLeadInjector$(dto: LeadInjectorCreateDto): Observable<ApiObjectModel<LeadInjectorDto>> {
    return this.httpClient.post<ApiObjectModel<LeadInjectorDto>>(this.baseUrl, dto)
  }

  patchLeadInjector$(id: number, dto: LeadInjectorUpdateDto, version: number) {
    return this.httpClient.patch<ApiObjectModel<LeadInjectorDto>>(this.baseUrl + `/${id}?version=${version}`, dto)
  }

}
